import { DrDisplayContainerDto } from '../dto';

export interface DrApiResultBase {
  success: boolean;
  errorMessage: string;
}

export interface DrGeneralContainerMetadataResult extends DrApiResultBase {
  containerMetadata: any; // DrContainerMetadataDto;
}

export interface DrDisplayContainerGetResult extends DrApiResultBase {
  design: DrDisplayContainerDto;
}
